import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Users, ShieldCheck, UserPlus } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated/admin/")({
  component: AdminOverview,
});

function AdminOverview() {
  const [stats, setStats] = useState({ users: 0, admins: 0, mods: 0, recent: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString();
      const [usersRes, adminsRes, modsRes, recentRes] = await Promise.all([
        supabase.from("profiles").select("*", { count: "exact", head: true }),
        supabase.from("user_roles").select("*", { count: "exact", head: true }).eq("role", "admin"),
        supabase.from("user_roles").select("*", { count: "exact", head: true }).eq("role", "moderator"),
        supabase.from("profiles").select("*", { count: "exact", head: true }).gte("created_at", sevenDaysAgo),
      ]);
      setStats({
        users: usersRes.count ?? 0,
        admins: adminsRes.count ?? 0,
        mods: modsRes.count ?? 0,
        recent: recentRes.count ?? 0,
      });
      setLoading(false);
    })();
  }, []);

  const cards = [
    { label: "Total users", value: stats.users, icon: Users, to: "/admin/roles" },
    { label: "Admins", value: stats.admins, icon: ShieldCheck, to: "/admin/roles" },
    { label: "Moderators", value: stats.mods, icon: ShieldCheck, to: "/admin/roles" },
    { label: "New (7 days)", value: stats.recent, icon: UserPlus, to: "/admin/roles" },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold">Overview</h2>
        <p className="text-sm text-muted-foreground">Snapshot of your platform.</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.to}
            className="rounded-lg border border-border bg-card p-5 transition-colors hover:bg-secondary/40"
          >
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
                {c.label}
              </span>
              <c.icon className="h-4 w-4 text-muted-foreground" />
            </div>
            <div className="mt-3 text-3xl font-bold tracking-tight">
              {loading ? "…" : c.value}
            </div>
          </Link>
        ))}
      </div>

      <div className="rounded-lg border border-border bg-card p-6">
        <h3 className="text-sm font-semibold">Quick actions</h3>
        <div className="mt-3 flex flex-wrap gap-2">
          <Link
            to="/admin/roles"
            className="rounded-md bg-gradient-brand px-3 py-2 text-xs font-semibold text-white shadow-glow hover:opacity-95"
          >
            Manage users
          </Link>
          <Link
            to="/admin/roles"
            className="rounded-md border border-border px-3 py-2 text-xs font-semibold hover:bg-secondary"
          >
            Manage roles
          </Link>
        </div>
      </div>
    </div>
  );
}
